import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import theme from '../../../theme';
import {Table, TableBody, TableCell, TableHead, TableRow}  from '@material-ui/core';
import {Paper, Menu, MenuItem, IconButton, ListItemIcon, ListItemText} from '@material-ui/core';
import MoreVert from '@material-ui/icons/MoreVert';
import PlayArrow from '@material-ui/icons/PlayArrow';
import Stop from '@material-ui/icons/Stop';
import EditIcon from '@material-ui/icons/Edit';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import WifiTethering from '@material-ui/icons/WifiTethering';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

import { sortByName } from '../../../api/helpers';
//import { PERMISSIONS } from '../../api/ServerApi';



class LicensesList_ extends React.Component{
    
    constructor(props){
        super(props);
        this.state = {
            //licenses: this.props.licenses,
            menuAnchor: null, 
            menuLicense: '',
            selectedLicense: ''
        }

    }

    handleLicenseSelect(RegName){
        this.setState({selectedLicense: RegName})
        //console.log('select network '+networkID)
        //this.props.onLicenseSelect(licenseID)
    }

    getRowStyle(RegName){
        let selected = RegName === this.state.selectedLicense
        let style = {
            background: selected? theme.palette.background.selectedRow : '',
            cursor: 'pointer'
        }
        return style
    }

    handleMenuClick(event, RegName){
        this.setState({menuAnchor: event.currentTarget, menuLicense: RegName});
        event.stopPropagation();
    }

    handleMenuClose(){
        this.menuAnchor = null;
        this.setState({menuAnchor: null, menuLicense: null});
        return null;
    }

    handleMenuItemClick(menu, RegName){
        RegName = RegName ? RegName : this.state.menuLicense
        this.handleMenuClose();
        this.props.onLicenseMenu(menu, RegName)
    }

    checkPermission(permission){
        return this.props.onAction({
            type:'CHECK_PERMISSION', 
            permission: permission 
        })
    }

    render(){
        const {t} = this.props

        //this.state.licenses.sort(sortByName)

        const styles = {
            paper: {
              width: '100%',
              overflowX: 'auto',
            },
            head: {
                color: theme.palette.color.dialogTitle,
                backgroundColor: theme.palette.background.dialogTitle,
            },
            addIcon: {
                color: 'white'
            }
        };

        return(
            <>
                <Paper style={styles.paper}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell colSpan={1} style={styles.head}>{t('RegistrationName')}</TableCell>
                                <TableCell colSpan={1} style={styles.head}>{t('Product')}</TableCell>
                                <TableCell colSpan={1} style={styles.head}>{t('Quantity')}</TableCell>
                                <TableCell colSpan={1} style={styles.head}>{t('ExpiryDate')}</TableCell>
                                <TableCell colSpan={1} style={styles.head}>{t('State')}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {this.props.licenses.map((license) => 
                            <TableRow key={license.RegName} 
                                    onClick={()=>{this.handleLicenseSelect(license.RegName)}}
                                    onDoubleClick={()=>{this.handleMenuItemClick('NETWORK_EDITOR_OPEN_EDIT', license.RegName)}}
                                    style={this.getRowStyle(license.RegName)}>

                                <TableCell component="th" scope="row">
                                    {license.RegName}
                                </TableCell>

                                <TableCell component="th" scope="row">
                                    {license.ProductName}
                                </TableCell>

                                <TableCell component="th" scope="row">
                                    {license.Quantity}
                                </TableCell>

                                <TableCell component="th" scope="row">
                                    {license.ExpiryDate}
                                </TableCell>

                                <TableCell component="th" scope="row">
                                    {license.State}
                                </TableCell>

                                {/*
                                <TableCell>
                                  {net.CommandPort}
                                </TableCell>
                                <TableCell>
                                    {net.devices?net.devices.length:0}
                                </TableCell>
                                 */}
                                
                            </TableRow>
                        )}
                        </TableBody>

                    </Table>
                </Paper>
            </>
        )

    }

}

export const LicensesList = withTranslation()(LicensesList_);